import { useEffect } from 'react'
import { matchPath, useLocation } from 'react-router'

import useUndoableDeleteSystem from '../systems/useUndoableDeleteSystem'

const projectIDFromPathname = ( pathname: string ): number | undefined => {
	const match = matchPath<{ projectID?: string }>( pathname, { path: '/projects/:projectID' } )
	const projectID = Number( match?.params.projectID )

	return Number.isInteger( projectID ) ? projectID : undefined
}

const useDismissUndoablesOnNavigation = () => {
	const undoableDeleteSystem = useUndoableDeleteSystem()
	const { pathname } = useLocation()

	useEffect( () => {
		undoableDeleteSystem.dismissUndoablesOutsideProject( projectIDFromPathname( pathname ) )
	}, [ pathname, undoableDeleteSystem ] )
}

export default useDismissUndoablesOnNavigation
